import { z } from "zod";

// 👉 schema para un accionista
const AccionistasSchema = z.object({
  tipoDocumento: z
    .string({
      required_error: "El tipo de documento es obligatorio",
    })
    .nonempty("Campo obligatorio"),
  numeroDocumento: z
    .string()
    .min(5, "Número de documento inválido")
    .max(30, "Número de documento demasiado largo"),
  nombre: z.string().min(2, "Nombre o razón social requerido"),
  telefono: z
    .string()
    .regex(/^[0-9+\-()\s]*$/, "Teléfono inválido")
    .optional()
    .or(z.literal("")), // permite vacío
  pais: z
    .string({
      required_error: "El pais es obligatorio",
    })
    .min(1, "El pais es obligatorio"),
  departamento: z.string().optional(),
  ciudad: z.string().optional(),
  porcentaje: z.union([z.string(), z.number()]).refine(
    (val) => {
      const num = typeof val === "string" ? parseFloat(val) : val;
      return !isNaN(num) && num >= 5 && num <= 100;
    },
    { message: "El porcentaje debe estar entre 5 y 100" }
  ),
});

// 👉 schema para el paso completo
export const accionistasStepSchema = z.object({
  accionistas: z.array(AccionistasSchema).optional(),
});

export type AccionistasStepSchema = z.infer<typeof accionistasStepSchema>;
